import { PopupboxComponent } from './popupbox.component';

export const POPUPBOX_DIRECTIVES = [PopupboxComponent] as const;
export * from './popupbox.component';
